import { ConfigLayout, ConfigurationType } from "./types";

export const NAME_SEPARATOR = " | ";

// NOTE: reserved name for the home-wide config option, which is not pickable.
// The "__" prefix is rejected by the option-name validator, so an authored name
// can never collide with it. Distinct from ConfigurationType "base", which is a
// scope level in the base -> region -> community -> user chain.
export const BASE_OPTION_NAME = "__base__";

export const RESERVED_NAME_PREFIX = "__";

export const configurationTypeLabel: Record<ConfigurationType, string> = {
  base: "Base",
  region: "Region",
  community: "Community",
  user: "User",
};

export const layoutOptions: ConfigLayout[] = [
  { value: "tile-carousel", label: "Tile carousel" },
  { value: "list-row", label: "List row" },
  { value: "photo-card", label: "Photo card" },
  { value: "photo-hero", label: "Photo hero" },
  { value: "scheme-card", label: "Scheme card" },
];

// antd <Tag color> preset names (not hex/rgba) — one per scope level.
export const typeColor: Record<ConfigurationType, string> = {
  base: "blue",
  region: "green",
  community: "orange",
  user: "purple",
};

export type ConfigRowAction =
  | { action: "editOptions"; label: string }
  | { action: "editBaseOption"; label: string }
  | { action: "create"; label: string; type: ConfigurationType }
  | { action: "delete"; label: string };

export const childAddOptions: Record<ConfigurationType, ConfigRowAction[]> = {
  base: [
    { action: "editBaseOption", label: "Edit Base Option" },
    { action: "editOptions", label: "Edit Options" },
    { action: "create", label: "Add Region", type: "region" },
    { action: "create", label: "Add User", type: "user" },
    { action: "delete", label: "Delete" },
  ],
  region: [
    { action: "editOptions", label: "Edit Options" },
    { action: "create", label: "Add Community", type: "community" },
    { action: "create", label: "Add User", type: "user" },
    { action: "delete", label: "Delete" },
  ],
  community: [
    { action: "editOptions", label: "Edit Options" },
    { action: "create", label: "Add User", type: "user" },
    { action: "delete", label: "Delete" },
  ],
  user: [
    { action: "editOptions", label: "Edit Options" },
    { action: "delete", label: "Delete" },
  ],
};
